module.exports = __webpack_public_path__ + "img/headerLogo.ea0bd61.png";